import styled from "styled-components";

const Note = styled.p`
  color: #ffffff;
  font-size: 1.125rem;
  line-height: 1.5;
  margin: 0;
  padding: 0;
`;

export default Note;



// WEBPACK FOOTER //
// ./src/components/Note/index.jsx